import { createApp } from 'vue'
import App from './views/Basket.vue'
import BasketIcon from './views/BasketIcon.vue'
import router from './router'
import store from './store'
import VueTheMask from 'vue-the-mask'

createApp(BasketIcon).use(store).use(router).mount('.cartIcon')
createApp(App).use(VueTheMask).use(store).use(router).mount('.basket-page')
